export type CrmPipelineStageCode = 'lead' | 'contacted' | 'qualified' | 'proposal' | 'won' | 'lost';
export type CrmTaskPriorityCode = 'low' | 'normal' | 'high' | 'urgent';
export type CrmFollowUpFilter = 'overdue' | 'upcoming' | 'none';

export const CRM_PIPELINE_STAGES: CrmPipelineStageCode[] = ['lead', 'contacted', 'qualified', 'proposal', 'won', 'lost'];

export const CRM_PIPELINE_STAGE_LABELS: Record<CrmPipelineStageCode, string> = {
  lead: 'Новий лід',
  contacted: 'Контакт встановлено',
  qualified: 'Кваліфікований',
  proposal: 'Пропозиція надіслана',
  won: 'Успішно закрито',
  lost: 'Втрачено',
};

export const CRM_TASK_PRIORITIES: CrmTaskPriorityCode[] = ['low', 'normal', 'high', 'urgent'];

export const CRM_TASK_PRIORITY_LABELS: Record<CrmTaskPriorityCode, string> = {
  low: 'Низький',
  normal: 'Звичайний',
  high: 'Високий',
  urgent: 'Терміновий',
};

export const CRM_FOLLOW_UP_FILTERS: Array<{ value: CrmFollowUpFilter; label: string }> = [
  { value: 'overdue', label: 'Прострочені' },
  { value: 'upcoming', label: 'Заплановані' },
  { value: 'none', label: 'Без дати контакту' },
];

export const stageLabel = (code?: string | null): string =>
  (code && CRM_PIPELINE_STAGE_LABELS[code as CrmPipelineStageCode]) || code || '';

export const priorityLabel = (code?: string | null): string =>
  (code && CRM_TASK_PRIORITY_LABELS[code as CrmTaskPriorityCode]) || code || '';

export const toLocalInputValue = (iso?: string | null): string => {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const fromLocalInputValue = (value: string, originalIso?: string | null): string | null => {
  if (!value) return null;
  // Keep server precision when an edit does not change the minute-resolution input.
  if (originalIso && value === toLocalInputValue(originalIso)) return originalIso;
  return new Date(value).toISOString();
};

/** True when a next-contact date is scheduled and has already passed relative to `now`. */
export const isFollowUpOverdue = (nextContactAtUtc?: string | null, now: Date = new Date()): boolean =>
  !!nextContactAtUtc && new Date(nextContactAtUtc).getTime() < now.getTime();

/** True when a task is not completed and its due date has already passed relative to `now`. */
export const isTaskOverdue = (
  dueAtUtc: string | null | undefined,
  isCompleted: boolean,
  now: Date = new Date()
): boolean => !isCompleted && !!dueAtUtc && new Date(dueAtUtc).getTime() < now.getTime();
